// extracted by mini-css-extract-plugin
export default {"Landing":"Landing_Landing__xKxa3","Landing__Details":"Landing_Landing__Details__AXrSO"};